export const safeParseURL = (urlString, base) => {
  try {
    return new URL(urlString, base);
  } catch {
    return null;
  }
};
